<template>
  <v-col cols="12" class="text-center fill-height" style="position: relative">
    <v-row
      no-gutters
      id="panzoom"
      class="fill-height"
      justify="center"
      align="center"
      style="position: absolute; width: 100%; z-index: 1"
      @dragover.prevent
      @drop.prevent="dragFinish($event)"
    >
      <ul class="tree" style="z-index: 2">
        <organogram-node
          v-for="(item, idx) in structure"
          :key="idx"
          :item="item"
          :mode="mode"
          @groupDeleted="groupDeleted"
        ></organogram-node>
      </ul>
    </v-row>
  </v-col>
</template>

<script>
import Panzoom from "@panzoom/panzoom";

export default {
  props: ["structure", "mode"],
  data() {
    return {
      panZoom: null,
    };
  },
  mounted() {
    const elem = document.getElementById("panzoom");

    if (this.mode == "select") {
      self.panZoom = Panzoom(elem, {
        maxScale: 3,
      });
    }

    //self.panZoom.pan(500, 500);
    //self.panzoom.zoom(1, { animate: true });

    // Panning and pinch zooming are bound automatically (unless disablePan is true).
    // There are several available methods for zooming
    // that can be bound on button clicks or mousewheel.
    //button.addEventListener("click", panzoom.zoomIn);
    //elem.addEventListener("wheel", self.panZoom.zoomWithWheel);
  },
  methods: {
    dragFinish(ev) {
      let self = this;

      let methodType = ev.dataTransfer.getData("methodType");

      if (methodType == "create") {
        let filterId = ev.dataTransfer.getData("filterId");

        self.addRoot(filterId);
      } else {
        let draggedItem = self.$store.getters.getDraggedItem;

        self.$store.getters.getNode(draggedItem.parentId).then((parent) => {
          self.updateGroup(draggedItem, parent);
        });
      }
    },
    addRoot(itemId) {
      let self = this;

      self
        .post(`Hierarchy/CreateFilter`, {
          hierarchyId: self.$route.params.id,
          providerFilterValueId: itemId,
          parentId: null,
        })
        .then((r) => {
          if (r.data.success) {
            self.structure.push(r.data.data);
          }
        });
    },
    updateGroup(item, parent) {
      let self = this;

      item.parentId = null;

      self.put(`Hierarchy/UpdateFilter?filterId=${item.id}`, item).then((r) => {
        if (r.data.success) {
          parent.children.splice(parent.children.indexOf(item), 1);
          self.structure.push(item);
        }
      });
    },
    groupDeleted(item) {
      let self = this;

      self.structure.splice(self.structure.indexOf(item), 1);
    },
  },
};
</script>

<style>
/* It's supposed to look like a tree diagram */
.tree,
.tree ul,
.tree li {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.tree {
  margin: 0 0 1em;
  text-align: center;
}
.tree,
.tree ul {
  display: table;
}
.tree ul {
  width: 100%;
}
.tree li {
  display: table-cell;
  padding: 0.5em 0;
  vertical-align: top;
}
/* _________ */
.tree li:before {
  outline: solid 1px #666;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.tree li:first-child:before {
  left: 50%;
}
.tree li:last-child:before {
  right: 50%;
}

.tree code,
.tree span {
  border: solid 0.1em #666;
  border-radius: 0.2em;
  display: inline-block;
  margin: 0 0.2em 0.5em;
  padding: 0.2em 0.5em;
  position: relative;
  z-index: 2;
}

/* | */
.tree ul:before,
.tree code:before,
.tree span:before {
  outline: solid 1px #666;
  content: "";
  height: 0.5em;
  left: 50%;
  position: absolute;
}
.tree ul:before {
  top: -0.5em;
}
.tree code:before,
.tree span:before {
  top: -0.55em;
}

/* The root node doesn't connect upwards */
.tree > li {
  margin-top: 0;
}
.tree > li:before,
.tree > li:after,
.tree > li > code:before,
.tree > li > span:before {
  outline: none;
}

.menu-button {
  position: absolute;
  top: 0;
  right: 0;
}

.node-selected {
  background-color: #ff7200 !important;
}
</style>